import { useState } from "react";
import { Modal, Tabs } from "antd";
import { IPendingAdminUnlockUser } from "../hooks/useGetPendingAdminUnlockUsers";
import { useApproveAdminUnlock } from "../hooks/useApproveAdminUnlock";
import { useRejectAdminUnlock } from "../hooks/useRejectAdminUnlock";
import useGetUnlockApprovalsByReference from "../hooks/useGetUnlockApprovalsByReference";
import RequestDetailsTab from "./RequestDetailsTab";
import ApprovalHistoryTab from "./ApprovalHistoryTab";

interface IUnlockRequestModalProps {
  user: IPendingAdminUnlockUser;
  onClose: () => void;
  onSuccess: () => void;
}

export default function UnlockRequestModal({
  user,
  onClose,
  onSuccess,
}: IUnlockRequestModalProps) {
  const [approvalComment, setApprovalComment] = useState("");
  const [actionType, setActionType] = useState<"approve" | "reject" | null>(
    null,
  );

  const { mutate: approveMutate, result: approveResult } =
    useApproveAdminUnlock();
  const { mutate: rejectMutate, result: rejectResult } = useRejectAdminUnlock();

  const { data: approvalData, isLoading: isLoadingApprovals } =
    useGetUnlockApprovalsByReference({
      ssoUserId: user.sssoUserId,
      transactionReference: user.transactionReferenceNumber,
    });

  const handleAction = (type: "approve" | "reject") => {
    const payload = {
      transactionReferenceNumber: user.transactionReferenceNumber,
      approvalComment,
      ssoUserId: user.sssoUserId,
    };
    const mutate = type === "approve" ? approveMutate : rejectMutate;
    mutate(payload, { onSuccess });
  };

  return (
    <Modal
      title={<h2 className="text-2xl font-semibold">Unlock Request Details</h2>}
      open
      onCancel={onClose}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: "80vh", overflow: "auto" }}
    >
      <div className="p-4">
        <Tabs
          defaultActiveKey="details"
          items={[
            {
              key: "details",
              label: "Request Details",
              children: (
                <RequestDetailsTab
                  user={user}
                  approvalComment={approvalComment}
                  onCommentChange={setApprovalComment}
                  actionType={actionType}
                  approveResult={approveResult}
                  rejectResult={rejectResult}
                  onApprove={() => {
                    setActionType("approve");
                    handleAction("approve");
                  }}
                  onDecline={() => {
                    setActionType("reject");
                    handleAction("reject");
                  }}
                />
              ),
            },
            {
              key: "history",
              label: "Approval History",
              children: (
                <ApprovalHistoryTab
                  data={approvalData?.data}
                  isLoading={isLoadingApprovals}
                />
              ),
            },
          ]}
        />
      </div>
    </Modal>
  );
}
